import { DashboardNotifications, PaymentProviderType } from '@dev/ee-api/ee-api-models';

import { getNotificationStore } from '@api/store/notifications/actions';
import { getProviders } from '@api/store/payments/actions';
import { identity } from 'lodash-es';
import { useDialog } from '../Dialog/useDialog';
import { useSelector } from 'react-redux';
import { getDashboardSeenNotificationsStore } from '@api/store/dashboardSeenNotifications/actions';
import { DialogIds } from '../Dialog/DialogIds.enum';

const STRIPE_POLICY_CHANGE_NOTIFICATION_NAME = 'StripePolicyChange';

export const useNotificationCenter = () => {
    const notifications = useSelector(getNotificationStore);
    const providers = useSelector(getProviders);
    const { showDialog } = useDialog();
    const dashboardSeenNotifications = useSelector(getDashboardSeenNotificationsStore);

    const availableNotifications = (name: string) => {
        const personaSurveyNotificationConfig = {
            availableDialog: Object.values({
                hasNotification: notifications?.notificationList?.some((notification) =>
                    notification?.DashboardNotifications?.includes?.(name as DashboardNotifications)
                ),
                hasNotSeen:
                    dashboardSeenNotifications.isLoaded && !dashboardSeenNotifications.list?.includes(name as DashboardNotifications),
            }).every(identity),
            dialogId: DialogIds.PersonaSurveyDialog,
            /**
             *
             */
            availableBanner: false,
        };
        return {
            [DashboardNotifications.StripePolicyChange]: {
                availableDialog: false,
                dialogId: null,
                /**
                 *
                 */
                availableBanner: Object.values({
                    hasNotification: notifications?.notificationList?.some(
                        (notification) => notification.Name === STRIPE_POLICY_CHANGE_NOTIFICATION_NAME
                    ),
                    hasStripeProvider: providers?.some((p) => p.Type === PaymentProviderType.Stripe),
                }).every(identity),
            },
            [DashboardNotifications.SophieMarketingNotification]: personaSurveyNotificationConfig,
            [DashboardNotifications.JakeMarketingNotification]: personaSurveyNotificationConfig,
            [DashboardNotifications.AlexMarketingNotification]: personaSurveyNotificationConfig,
            [DashboardNotifications.LindaMarketingNotification]: personaSurveyNotificationConfig,
            /**
             * methods
             */

            getNotificationConfig() {
                return this?.[name] || { availableDialog: false, dialogId: null, availableBanner: false };
            },
        };
    };

    const getNotificationConfig = (notificationToShow: DashboardNotifications) =>
        availableNotifications(notificationToShow).getNotificationConfig();

    const showNotificationDialog = (notificationToShow: DashboardNotifications) => {
        const { availableDialog, dialogId } = getNotificationConfig(notificationToShow);

        if (!availableDialog) return;
        showDialog(dialogId);
    };

    const showNotificationBanner = (notificationToShow: DashboardNotifications) => {
        const { availableBanner } = getNotificationConfig(notificationToShow);

        return availableBanner;
    };

    return {
        showNotificationDialog,
        showNotificationBanner,
    };
};
